<header class="navbar navbar-default navbar-static-top">
    <div class="navbar-header full-width">
        <a class="sidebar-mobile-toggler pull-left hidden-lg btn btn-navbar sidebar-toggle" (click)="toggleMainMenu($event)">
            <i class="icon-ic-menu"></i>
        </a>

        <h4 class="page-heading">{{ 'headings.' + heading | translate }}</h4>
    </div>
</header>
